import { useMemo } from 'react';
import { useAppSelector } from 'store/configureStore';
import { tenantSettingsTenantFeaturesSelector } from 'store/selectors/tenant-settings';

const useTenantFeature = (featureName: string) => {
  const tenantFeatures = useAppSelector(tenantSettingsTenantFeaturesSelector);

  return useMemo(
    () =>
      tenantFeatures?.find((feature) => feature.featureName === featureName) ??
      null,
    [tenantFeatures, featureName],
  );
};

export default useTenantFeature;
